import React from 'react';

const TodoHeader = () =>{
    return(<div className='header'>
        <h1>Task List</h1>
    </div>);
}

export default TodoHeader;